module.exports = __webpack_public_path__ + "images/flyfish8c04a5cac3f49a5740e2306adea5ba35.png";